export const gbp = (v) => (Number(v) || 0).toLocaleString('en-GB', { style: 'currency', currency: 'GBP' });
export const ukDate = (iso) => {
  if (!iso) return '';
  const [y, m, d] = String(iso).slice(0, 10).split('-');
  return d && m && y ? `${d}/${m}/${y}` : iso;
};
export const LINE_TYPES = [
  { key: 'labour', label: 'Labour', cis: true },
  { key: 'materials', label: 'Materials', cis: false },
  { key: 'fuel', label: 'Fuel / travel', cis: true },
  { key: 'other', label: 'Other', cis: true },
];
export const typeLabel = (k) => LINE_TYPES.find(t => t.key === k)?.label || k;
export const STATUS_STYLE = {
  draft: 'bg-gray-500/20 text-gray-300 border-gray-500/30',
  issued: 'bg-blue-500/20 text-blue-300 border-blue-500/30',
  sent: 'bg-sky-500/20 text-sky-300 border-sky-500/30',
  approved: 'bg-amber-500/20 text-amber-300 border-amber-500/30',
  paid: 'bg-green-500/20 text-green-300 border-green-500/30',
  cancelled: 'bg-red-500/20 text-red-300 border-red-500/30',
};
export const STATUS_LABEL = { draft: 'Draft', issued: 'Issued', sent: 'Sent', approved: 'Approved by LUX', paid: 'Paid', cancelled: 'Cancelled' };

/** Client-side mirror of the server totals so the review step is instant. */
export function computeTotals(lines, cisRate) {
  const r2 = (v) => Math.round((Number(v) || 0) * 100) / 100;
  const gross = r2(lines.reduce((s, l) => s + (Number(l.amount) || 0), 0));
  const base = r2(lines.filter(l => l.cis_applies).reduce((s, l) => s + (Number(l.amount) || 0), 0));
  const ded = r2(base * (Number(cisRate) || 0) / 100);
  return { gross_total: gross, cis_base: base, cis_exempt: r2(gross - base), cis_rate: Number(cisRate) || 0, cis_deduction: ded, net_payable: r2(gross - ded) };
}
export const cisRateOf = (profile) => { const s = String(profile?.cis_status || '20'); return s === '0' || s === 'gross' ? 0 : s === '30' ? 30 : 20; };
